import PropTypes from "prop-types";
import { Button } from "@mui/material";

import { useFaces, useFaceOrg, useRouter, useTemplateGroup } from "hooks";
import Placeholder from "components/Placeholder";
import TemplateGroupPresenter from "presenters/TemplateGroupPresenter";
import { appRoutes } from "routes";
import { ENTRY_POINTS } from "enums";

const CreateButton = ({ loading, buttonText, size = "large" }) => {
  const { location, push } = useRouter();
  const { setEntryPoint } = useFaceOrg();
  const { templateGroup } = useTemplateGroup();
  const { faces, openModal: openFacesModal } = useFaces();

  const handleClick = () => {
    const slug = TemplateGroupPresenter.id(templateGroup);
    const hasFaces = faces && faces.length > 0;

    if (hasFaces && TemplateGroupPresenter.isInvite(templateGroup)) {
      push({ pathname: appRoutes.invitesCastingPath(slug), state: { referrer: location.pathname } });
    } else if (hasFaces || TemplateGroupPresenter.isStraightUp(templateGroup)) {
      push({ pathname: appRoutes.newCastPath(slug), state: { referrer: location.pathname } });
    } else {
      setEntryPoint(ENTRY_POINTS.PREVIEW);
      openFacesModal();
    }
  };

  const renderPlaceholder = () => {
    return <Placeholder variant="rect" ratio="5/1" />;
  };

  const renderButton = () => {
    return (
      <Button onClick={handleClick} variant="contained" color="primary" size={size}>
        {buttonText}
      </Button>
    );
  };

  return loading ? renderPlaceholder() : renderButton();
};

CreateButton.propTypes = {
  loading: PropTypes.bool,
  buttonText: PropTypes.string,
  size: PropTypes.string,
};

export default CreateButton;
